import { PageMeta } from '@/components/ui/PageMeta';
import { LegalDocumentView } from '@/components/legal/LegalDocumentView';

export function DataDeletionPage() {
  return (
    <>
      <PageMeta
        title="Exclusão de Dados | Operax"
        description="Como pedir exclusão de dados pessoais tratados pela Operax (LGPD)."
      />
      <LegalDocumentView code="data_deletion" fallbackTitle="Exclusão de Dados" />
    </>
  );
}
